import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { AuctionResult } from '../../models/auction-result';
export class AuctionResultsApi extends ApiBase {
  model = 'admin/auction-results';

  public patch(id: string, data?: AuctionResult): Observable<AuctionResult> {
    return this.http.patch<AuctionResult>(this.buildUrl(id), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(this.buildUrl(id), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public massFulfill(auctionId: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      this.buildUrl('mass-fulfilled', auctionId),
      {},
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public receipt(id: string, emailCopy?: string) {
    return this.http.post(
      this.buildUrl(id, 'receipt'),
      { emailCopy },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public massReceipts(id: string, emailCopy?: string) {
    return this.http.post(
      this.buildUrl('mass-receipt', id),
      { emailCopy },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public trackingNumber(id: string, trackingNumber?: string) {
    return this.http.post(
      this.buildUrl(id, 'send-tracking-number'),
      { trackingNumber },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }
}
